export const contactConstants = [
  {
    contactLink: "#",
    contactIcon: "fab fa-linkedin fa-2xl",
  },
  {
    contactLink: "#",
    contactIcon: "fab fa-twitter-square fa-2xl",
  },
  {
    contactLink: "#",
    contactIcon: "fab fa-github fa-2xl",
  },
  {
    contactLink: "#",
    contactIcon: "fab fa-stack-overflow fa-2xl",
  },
  {
    contactLink: "#",
    contactIcon: "fab fa-medium fa-2xl",
  },
];
